/**
 *
 * @returns Scroll to top in current page
 */
export const scrollToTop = () =>
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
